<template>
	<div :is="elementType" ref="container" v-cloak>
		<slot></slot>
	</div>
</template>

<script>
    export default {
        data() {
            return {}
        },

		props: {
			elementType: {
        		default: 'div'
			},

			hasMorePages: {
				default: false,
				type: Boolean,
			}
		},

		computed: {
			infiniteScrollElement() {
				if(this.$refs.container.$el) {
					return this.$refs.container.$el;
				}
				return this.$refs.container;
			}
		},

		methods: {
        	addScrollListener() {
				this.$nextTick(() => {
					this.infiniteScrollElement.addEventListener(
						"scroll", () => {
							if(this.bottomVisible() && this.hasMorePages) {
								this.$emit('bottom');
							}
						}, { passive: true }
					);
				});
			},

			bottomVisible() {
				const scrollY = this.infiniteScrollElement.scrollTop;
				const visible = this.infiniteScrollElement.clientHeight;
				const pageHeight = this.infiniteScrollElement.scrollHeight;
				const bottomOfPage = visible + scrollY >= pageHeight;
				return bottomOfPage || pageHeight < visible;
			},
		},

		created() {
        	this.addScrollListener();

        	this.$nextTick(() => {
        		if(this.bottomVisible()) {
        			this.$emit('bottom');
				}
			})
		},
    }
</script>
